import React from 'react';

import { IDetailsProps } from './props';
import Code from '../../dtos/Code';

import Imbel from './Imbel';
import Saas, { SaasProps } from './Saas';
import { CodeContainer, InfoContainer } from './styles';

function isSaasProps(object: any): object is SaasProps {
  return 'fields' in object && 'value' in object && 'resourceId' in object;
}

interface DetailsProps<T = Code | SaasProps> {
  code: T;
}

const Details: React.FC<DetailsProps> = ({ code }) => {
  let ComponentToRender: React.FC<IDetailsProps>;
  let componentProps: SaasProps | Code | {};

  if (isSaasProps(code)) {
    ComponentToRender = Saas;
    componentProps = code;
  } else {
    ComponentToRender = Imbel;
    componentProps = code;
  }

  return (
    <CodeContainer>
      <InfoContainer>
        <ComponentToRender data={componentProps as any} />
      </InfoContainer>
    </CodeContainer>
  );
}

export default Details;
